import wordings from './metrics-wording.json';
import { ForecastParamCode } from 'pleinchamp-api-client';

export type WordingObject = {
  titlePreferences: string;
  title: string;
  desc36h: string | null;
  desc15d: string | null;
  descHour: string | null;
  descPreferences: string | null;
};

export const metricsWording = wordings as unknown as Record<ForecastParamCode, WordingObject>;

export function getMetricWording(forecastParam: ForecastParamCode, type: MetricWordingType): string | null {
  return metricsWording[forecastParam][type];
}
